import { styled } from 'parkdepot-shared/theme'

const Wrapper = styled('div', ({ $theme }) => ({
    height: 'calc(100vh - 20rem)',
    position: 'relative',

    [$theme.mediaQuery.medium]: {
        height: 'calc(100vh - 25rem)'
    },

    [$theme.mediaQuery.large]: {
        width: '100%',
        borderRadius: '2.4rem',
        overflow: 'hidden',
        height: 'calc(100vh - 20rem)'
    }
}))

export default Wrapper
